import React, { useEffect, useState } from "react";
import { graphql } from "gatsby";
import * as styles from "./memes.module.css";

export default function Memes({ data }) {
  return (
    <section className={styles.photos}>
      {console.log(data)}
      {data.allMarkdownRemark.edges.map(value => (
        <div style={{ position: "relative" }}>
          <img src={value.node.frontmatter.image} />
          <p className={styles.caption}>{value.node.frontmatter.caption}</p>
        </div>
      ))}
    </section>
  );
}

export const query = graphql`
  query {
    allMarkdownRemark(filter: { fileAbsolutePath: { regex: "//memes//" } }) {
      edges {
        node {
          frontmatter {
            caption
            image
          }
        }
      }
    }
  }
`;
